import React from "react";
import {Link} from "react-router";
import type {IconButtonProps, SvgIconProps} from "@mui/material";
import {Grid, IconButton, Tooltip} from "@mui/material";
import {Edit, Launch} from "@mui/icons-material";

type Props = {
    children?: React.ReactNode
    link?: string
    tooltip?: string
    noEditPermTooltip?: string
    hasEditPermission?: boolean
    IconButtonProps?: IconButtonProps
    IconProps?: SvgIconProps
}
export const EditLinkWrapper: React.FC<Props> = ({
                                                     children,
                                                     link,
                                                     tooltip,
                                                     noEditPermTooltip,
                                                     hasEditPermission,
                                                     IconButtonProps,
                                                     IconProps
                                                 }) => {
    if (!link) {
        return <>{children}</>
    }
    if (hasEditPermission === undefined) hasEditPermission = true;
    if (!hasEditPermission) tooltip = noEditPermTooltip !== undefined ? noEditPermTooltip : tooltip;
    const button = <IconButton {...IconButtonProps}>
        {hasEditPermission
            ? <Edit fontSize="small" {...IconProps}/>
            : <Launch fontSize="small" {...IconProps}/>
        }
    </IconButton>;
    return <Grid container alignItems="center" justifyContent="space-evenly" className="edit-link-wrapper">
        <Grid size={12}>
            <Link
                // Navigate via right click; Add the intent to the URL params
                to={link}
                target="_blank"
                rel="noopener noreferrer">
                {tooltip ? <Tooltip title={tooltip}>{button}</Tooltip> : button}
            </Link>
            {children}
        </Grid>
    </Grid>
}
